import React from "react";
// import Img1 from "../../../assets/Dashboard/Sample/3daytrial.svg";
import Img1 from "../../../assets/new/3daytrial (2).svg";
// import Img2 from "../../../assets/Dashboard/Sample/BackImg2.svg";

export default function Sample() {
  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  return (
    <>
      <div className="bg-[#f4f8ff] py-8 px-5 flex flex-col items-center">
        <div className="flex flex-col items-center -mt-[55px] space-y-4">
          {/* <img
            src={Img2}
            alt="backimg"
            className="w-[500px] md:w-[700px] lg:w-[900px] xl:w-[1200px] object-contain"
          /> */}
          <img
            src={Img1}
            alt="backimg2"
            onClick={handlenav}
            className="w-[400px] sm:w-[500px] cursor-pointer md:w-[600px] lg:w-[800px] xl:w-[1000px] object-contain relative !-mt-4 sm:!-mt-5 md:!-mt-7 lg:!-mt-10 xl:!-mt-13"
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center bg-[#446EDE] pt-10 p-8 h-96 xl:h-[420px] -mt-[86px] min-[400px]:-mt-[78px] sm:-mt-[84px] md:-mt-[96px] lg:-mt-32 xl:-mt-[138px]">
        <h1 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] text-white mt-24 md:mt-32 xl:mt-40 leading-snug font-bold text-center lg:px-40">
          Start Your Free Trial Now!
        </h1>
        <div className="text-center w-full md:w-[80%] lg:px-14">
          <p className="text-xl md:text-[22px] my-4 mt-6 py-4 lg:px-28 text-white">
            Open outreach and business development opportunities. Get real
            verified emails today!
          </p>
        </div>
        <div className="text-center w-full flex justify-center mb-20">
          <button
            onClick={handlenav}
            className="bg-white text-[#1C88FC] font-semibold p-3 rounded-md hover:bg-hover hover:text-white w-[220px]"
          >
            3 Day Risk Free Trial
          </button>
        </div>
      </div>
    </>
  );
}
